// Site-wide switches flipped in Admin Hub → Feature Flags (#1717). The layout
// renders the ones that are on into
//   <meta name="wcwd-site-switches" content='["key", ...]'>
// A missing or unreadable tag means every switch is off. The layout only
// renders on a full page load, so a flip shows on the next full load.
export type SiteSwitchKey = 'break_even_calculator_public';

export function siteSwitchOn(key: SiteSwitchKey): boolean {
  try {
    const raw = document.querySelector('meta[name="wcwd-site-switches"]')?.getAttribute('content');
    const keys: unknown = raw ? JSON.parse(raw) : [];
    return Array.isArray(keys) && keys.includes(key);
  } catch {
    return false;
  }
}

export function useSiteSwitch(key: SiteSwitchKey): boolean {
  return siteSwitchOn(key);
}

// Whether founding organizer spots are still open (#2589). The layout renders
// <meta name="wcwd-founding-spots-open" content="true|false">; missing means closed.
export function useFoundingSpotsOpen(): boolean {
  return document.querySelector('meta[name="wcwd-founding-spots-open"]')?.getAttribute('content') === 'true';
}
